import { Box, InputAdornment, InputBase, Snackbar, Theme } from '@mui/material';
import React, { useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import MicIcon from '@mui/icons-material/Mic';
import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    searchBox: {
      display: 'flex',
      alignItems: 'center',
      // marginTop: theme.spacing(2),
      width: '100%',
      '@media (min-width: 1920px) and (max-width: 1940px)': {
        width: '95%',
      },
      '@media (min-width: 1440px) and (max-width: 1460px)': {
        width: '95%',
      },
      border: '0.38px solid #B2B3B7',
      borderRadius: '5px',
      // padding: 2,
    },
    inputBase: {
      backgroundColor: 'white',
      borderRadius: '5px',
      padding: theme.spacing(1),
      flexGrow: 1,
    },
  })
);

interface AppSearchBarProps {
  handleMicHold?: () => void;
  handleMicRelease?: () => void;
  localSearchInput: any;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  openSnackbar?: boolean;
}
const AppSearchBar: React.FC<AppSearchBarProps> = ({ handleMicHold, handleMicRelease, localSearchInput, handleChange, openSnackbar }) => {
  const classes = useStyles();
  const [isListening, setIsListening] = useState(false);

  const handleMicClick = () => {
    if (!('webkitSpeechRecognition' in window)) {
      alert('Speech Recognition is not supported in this browser.');
      return;
    }

    const recognition = new (window as any).webkitSpeechRecognition();
    recognition.lang = 'en-US';
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;

    recognition.onstart = () => {
      setIsListening(true);
      console.log('Voice recognition started');
    };

    recognition.onresult = (event: any) => {
      const transcript = event.results[0][0].transcript;
      console.log('Transcript:', transcript);
      // Create a synthetic event to pass to handleChange
      const syntheticEvent = {
        target: { value: transcript }
      } as React.ChangeEvent<HTMLInputElement>;
      handleChange(syntheticEvent);
    };

    recognition.onerror = (event: any) => {
      console.error('Speech recognition error:', event.error);
      alert('Error occurred during speech recognition. Please try again.');
    };

    recognition.onend = () => {
      setIsListening(false);
      console.log('Voice recognition ended');
    };

    recognition.start();
  };

  return (
    <>
      <Box className={classes.searchBox}>
        <InputBase
          sx={{
            borderRadius: '9px',
            height: '36px',
            fontSize: '12px',
            '@media (min-width: 1280px) and (max-width: 1300px)': {
              height: '24px',
              fontSize: '10px !important',
              borderRadius: '9px',
            },
          }}
          placeholder="Search"
          startAdornment={
            <InputAdornment position="start">
              <SearchIcon
                sx={{
                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                    fontSize: '15px !important',
                  },
                }}
              />
            </InputAdornment>
          }
          endAdornment={
            <InputAdornment position="end" onClick={handleMicClick} style={{ cursor: 'pointer' }}>
              <MicIcon
                sx={{
                  color: isListening ? 'red' : 'inherit',
                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                    fontSize: '15px !important',
                  },
                }}
              />
            </InputAdornment>
          }
          className={classes.inputBase}
          value={localSearchInput}
          onChange={handleChange}
        />
      </Box>
      <Snackbar open={isListening} onClose={() => { }} message="Microphone is on. You can speak now." />
    </>
  );
};

export default AppSearchBar;
